import { el } from '../ui/dom';
import type { AudioEngine } from './engine';
import { MUSIC_TRACKS, MusicPlayer } from './music';
import { SFX, SFX_NAMES, startWindBed } from './sfx';

/** ?soundboard — the audio twin of the ?gallery art grid: every effect, the
 * two shipped tracks, and the wind, one click each, for tuning by ear. */
export function mountSoundboard(root: HTMLElement, engine: AudioEngine): void {
  const player = new MusicPlayer(engine);
  let windStop: (() => void) | null = null;

  const button = (label: string, onclick: () => void): HTMLElement =>
    el('button', { class: 'sound-button', onclick: () => { engine.ensureUnlocked(); onclick(); } }, label);

  const grid = el('div', { class: 'soundboard-grid' });
  for (const name of SFX_NAMES) {
    grid.append(button(name, () => SFX[name]!(engine, Math.random)));
  }

  const trackRow = el('div', { class: 'soundboard-grid' });
  for (const track of MUSIC_TRACKS) {
    trackRow.append(button(`▶ ${track.label}`, () => void player.play(track.id)));
  }
  trackRow.append(button('■ stop music', () => player.stop()));

  const ambienceRow = el(
    'div',
    { class: 'soundboard-grid' },
    button('wind on', () => { windStop ??= startWindBed(engine, Math.random); }),
    button('wind off', () => { windStop?.(); windStop = null; }),
  );

  root.append(
    el(
      'div',
      { class: 'soundboard' },
      el('div', { class: 'soundboard-title' }, 'BOOMTOWN SOUNDBOARD'),
      el('div', { class: 'soundboard-note' }, 'Click anything — the first click wakes the audio engine.'),
      el('div', { class: 'soundboard-section' }, 'Effects'),
      grid,
      el('div', { class: 'soundboard-section' }, 'Music (CC0, no attribution)'),
      trackRow,
      el('div', { class: 'soundboard-section' }, 'Ambience'),
      ambienceRow,
    ),
  );
}
